import React from "react";

const useStopWatch = () => {
  const [time, setTime] = React.useState(0);

  const [isRunning, setIsRunning] = React.useState(false);

  React.useEffect(() => {
    let intervalId;
    if (isRunning) {
      intervalId = setInterval(() => setTime(time + 1), 10);
    }
    return () => clearInterval(intervalId);
  }, [isRunning, time]);

  const hours = Math.floor(time / 360000);

  const minutes = Math.floor((time % 360000) / 6000);

  const seconds = Math.floor((time % 6000) / 100);

  const milliseconds = time % 100;

  const start = () => setIsRunning(true);

  const stop = () => setIsRunning(false);

  const reset = () => {
    stop();
    setTime(0);
  };

  return {
    start,
    stop,
    reset,
    time: {
      hours,
      minutes,
      seconds,
      milliseconds,
      format: {
        long: `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
          .toString()
          .padStart(2, "0")}:${milliseconds.toString().padStart(2, "0")}`,
        short: `${hours}:${minutes.toString().padStart(2, "0")}`,
      },
    },
  };
};

export default useStopWatch;
